<ng-template #template>
  <div class="modal-header">
    @if (dialogData?.title?.length != 0) {
      <h5 class="modal-title m-title">{{dialogData?.title}}</h5>
    }
    @if (showClose) {
      <button type="button" class="btn-close close pull-right" aria-label="Close"
        (click)="modalRef?.close()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    }
  </div>
  @if (dialogData?.dialogType == dialogTypeEnum.Custom) {
    <div class="modal-body">
      <ng-container *ngTemplateOutlet="dialogData?.template!"></ng-container>
    </div>
  } @else {
    @if (dialogData?.text?.length != 0) {
      <div class="modal-body">
        <p>{{dialogData?.text}}</p>
      </div>
    }
    <div class="modal-footer">
      @if (dialogData?.dialogType == dialogTypeEnum.Confirm) {
        <button type="button" class="btn btn-secondary"
        (click)="modalRef?.close()">Cancel</button>
      }
      <button type="button" class="btn btn-primary" (click)="clickEvent!()">{{actionButtonText}}</button>
    </div>
  }
  <ng-template #showDefaultTemp>
    @if (dialogData?.text?.length != 0) {
      <div class="modal-body">
        <p>{{dialogData?.text}}</p>
      </div>
    }
    <div class="modal-footer">
      @if (dialogData?.dialogType == dialogTypeEnum.Confirm) {
        <button type="button" class="btn btn-secondary"
        (click)="modalRef?.close()">Cancel</button>
      }
      <button type="button" class="btn btn-primary" (click)="clickEvent!()">{{actionButtonText}}</button>
    </div>
  </ng-template>
</ng-template>